import { __assign } from "tslib";
import { createCompaniesApi } from '.';
import { createFakeGetResponder, createFakeDeleteResponder, createFakePostResponder, createFakePutResponder, isWildcard } from '../test-utils';
import { createHttpTestKit } from '../http/test-kit';
import { createSimpleCustomFieldsApiTestKitHandler } from '..';
export var createCompaniesApiTestkit = function (parent) {
    if (parent === void 0) { parent = 'localhost'; }
    var fakeHttp = createHttpTestKit();
    var api = createCompaniesApi(parent, fakeHttp);
    var base = "".concat(parent, "/companies");
    var handler = {
        whenGetAllCompanies: function () { return createFakeGetResponder(fakeHttp, "".concat(base)); },
        whenAddCompany: createFakePostResponder(fakeHttp, "".concat(base)),
        whenBulkAddCompanies: createFakePostResponder(fakeHttp, "".concat(base, "/bulk")),
        whenDeleteCompany: function (dto) { return createFakeDeleteResponder(fakeHttp, "".concat(base, "/").concat(dto.id)); },
        whenGetCompany: function (dto) { return createFakeGetResponder(fakeHttp, "".concat(base, "/").concat(dto.id)); },
        whenSearch: createFakePostResponder(fakeHttp, "".concat(base, "/search/admin")),
        whenUpdateCompany: createFakePutResponder(fakeHttp, "".concat(base)),
        whenCustomFields: createSimpleCustomFieldsApiTestKitHandler(base, fakeHttp),
        whenUpdateCompanyFields: function (dto) {
            return createFakePutResponder(fakeHttp, "/".concat(isWildcard(dto) ? '' : dto.id, "/fields"))(dto);
        },
        whenCompanyEmailDomainsCheck: createFakePostResponder(fakeHttp, "".concat(base, "/emailDomains/check")),
    };
    return __assign(__assign({}, api), handler);
};
//# sourceMappingURL=testkit.js.map